import { Button, Checkbox } from 'antd';
import React, { PureComponent } from 'react';
import { SettingsContentPanel } from '../../../common/SettingsContentPanel';
import { Flex } from '../../../common/Flex';
import { SettingFilled } from '@ant-design/icons';
import { ClosablePopover } from '../../../common/ClosablePopover';
import { FilterLogic } from '../../../../model/SOL49';
import { FilterSettings } from '../../../../model/client/SOL49';

export const DEFAULT_MEASURE_TV_SETTINGS: MeasureTvFilterSettings = {
    filterLogic: FilterLogic.UNION,
    config: null,
};

export interface MeasureTvFilterSettings extends FilterSettings<void> {}

export class MeasureTvFilterSettingsContent extends SettingsContentPanel<MeasureTvFilterSettings> {
    render() {
        return (
            <Flex direction="vertical" className="settings-content" style={{ width: '30em', padding: '1em' }}>
                <Flex className="label">
                    <Checkbox
                        checked={this.state.filterLogic === FilterLogic.INTERSECT}
                        onChange={value =>
                            this.setState({
                                filterLogic: value.target.checked ? FilterLogic.INTERSECT : FilterLogic.UNION,
                            })
                        }>
                        Show only common TVs concerned by selected measures
                    </Checkbox>
                </Flex>
                <Flex style={{ justifyContent: 'space-around' }}>
                    <Button onClick={this.handleApply}>Apply</Button>
                    <Button onClick={this.handleClose}>Close</Button>
                </Flex>
            </Flex>
        );
    }
}

interface MeasureTvFilterSettingsButtonProps {
    settings: MeasureTvFilterSettings;
    onSettingsChange: (settings: MeasureTvFilterSettings) => void;
}

export class MeasureTvFilterSettingsButton extends PureComponent<MeasureTvFilterSettingsButtonProps> {
    private settingsPopoverRef = React.createRef<ClosablePopover>();
    handleSettingsChange = (settings: MeasureTvFilterSettings) => {
        this.props.onSettingsChange?.(settings);
        this.settingsPopoverRef.current.hide();
    };
    getTvFlightsFilterSettingsContent = () => {
        return (
            <MeasureTvFilterSettingsContent
                settings={this.props.settings}
                onChange={this.handleSettingsChange}
                onClose={() => {
                    this.settingsPopoverRef.current.hide();
                }}
            />
        );
    };
    render() {
        return (
            <ClosablePopover
                key="settings-action"
                ref={this.settingsPopoverRef}
                trigger="click"
                placement="bottom"
                title={<div style={{ fontWeight: 'bold' }}>FILTER'S SETTINGS</div>}
                content={this.getTvFlightsFilterSettingsContent()}>
                <Button
                    onClick={() => this.settingsPopoverRef.current.show()}
                    style={{ backgroundColor: 'transparent', borderColor: 'transparent' }}>
                    <SettingFilled />
                </Button>
            </ClosablePopover>
        );
    }
}
